import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDevolutions } from '../../../actions/transferActions'
import { seeWineries } from '../../../actions/wineryActions'
import DevolutionsView from '../../../containers/Inventory/Devolutions/DevolutionsView'

const Devolutions = () => {
  const dispatch = useDispatch()
  const { isLoadingWineriesList, wineriesList } = useSelector(state => state.wineriesAdmin)
  const { devolutions  } = useSelector(state => state.tranfers)
  const [winery, setWinery] = useState(null)
  const [solved, setSolved] = useState(false)
  useEffect(() => {
    
    dispatch(seeWineries())
    return () => {

    }
  }, [])

  useEffect(() => {
    if (winery) {
      dispatch(getDevolutions(winery, solved=='true') )
    }



    return () => {

    }
  }, [winery, solved])

  return (
    <DevolutionsView wineries={wineriesList} winery={winery} setWinery={setWinery} setSolved={setSolved} solved={solved} devolutions ={devolutions} />
  )
}

export default Devolutions